import {IntermediatePart} from "../../intermediatePart";
import {LOOK_ROOM_TYPES} from "../../constants";
import {getCurrentRoomType} from "../../../../appLayout";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class BathTubFixture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_fixture";
    this.partName = "Fixture";
    this.translateId = "visualizer.bathroom.bathtub.bathtub_fixture";
    this.dbName = "Bathtub Fixture";
    this.canBeDisabled = true;
  }

  disabledClick() {
    const bathTubBody = this.getParent().bathTubBody;
    if (bathTubBody) {
      bathTubBody.disabled = this.disabled || !bathTubBody.canBeEnabled(); // true or check if it can be enabled;
    }
  }

  hideLayerCondition() {
    const bathParent = this.getParent();
    const comboParent = bathParent.layout.parts[ShowerTubCombo.id];
    return comboParent?.freeStandingTubActive()
  }

  getArrayOfConditions() {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      const bathtubParent = this.getParent();
      let conditions = super.getArrayOfConditions(); //roomLayout
      if (bathtubParent.bathTubBody && bathtubParent.bathTubBody.activeFeature && bathtubParent.bathTubBody.activeFeature.metaData["MountType"]) {
        conditions.push({
          propName: "MountType",
          propValue: bathtubParent.bathTubBody.activeFeature.metaData["MountType"]
        })
      }
      return conditions
    }
    return super.getArrayOfConditions()
  }

}
